// extracted by mini-css-extract-plugin
module.exports = {"calendarTimeSlot":"styles_calendarTimeSlot__GrZRF","isFree":"styles_isFree__58MRj"};